import React, { useEffect, useState } from 'react';

import {
  fieldObjectUsuario,
  headersMeusDadosLogsAcoes,
  valoresExibidosLogsAcoes,
} from './auxiliarMeusDados';
import SubAbas from './subabas';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomButton from '../../../components/CustomButton';
import CustomCol from '../../../components/CustomCol';
import CustomRow from '../../../components/CustomRow';
import Input from '../../../components/InputNew';
import Tabela from '../../../components/Tabela';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { getLogsAcoes } from '../../../services/logs/logsAcoesService';
import { ENTITY } from '../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../utils/functions';

const DadosAcessos: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_LogAcoes;
  const [data, setData] = useState<any[]>([]);

  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    descricao: '',
  });

  // Função para buscar dados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const logAcoesData = await getLogsAcoes();
        setData(logAcoesData);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    fetchData();
  }, []);

  // Dados da tabela
  const tableData = data.map((item) => ({
    ID: item.id,
    'Data/Hora': formatDate(item.dataAcao),
    Usuário: formataNomeMeioSiglas(item.nomeCompleto),
    Interface: item.interfaceSisAf,
    Entidade: item.entidade,
    'Registro (id)': item.registroId ?? '',
    Ação: item.tipoAcao,
    Detalhamento: item.detalhamento,
  }));

  // Dados do Offcanvas
  const offCanvasData = tableData;
  // const offCanvasData = data.map((item) => ({
  //   id: item.id,
  //   usuarioSisaf: formataNomeMeioSiglas(item.nomeCompleto),
  //   dataAcao: formatDate(item.dataAcao),
  //   interfaceSisAf: item.interfaceSisAf,
  //   tipoAcao: item.tipoAcao,
  //   entidade: item.entidade,
  //   registroId: item.registroId ?? '-',
  //   detalhamento: item.detalhamento,
  // }));

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'interfaceSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      descricao: '',
    });
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="125px">
              <Input
                name="id"
                label="ID"
                value={formFiltros.descricao}
                id="descricao"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="200px">
              <Input
                name="descricao"
                label="Data do Log"
                value={formFiltros.descricao}
                id="descricao"
                type="date"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                name="usuario"
                label="Usuário"
                value={formFiltros.descricao}
                id="usuario"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
        <Tabela
          headers={headersMeusDadosLogsAcoes}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          rowClickable={false}
          minHeight="75vh"
          tituloCanvas="LOG DE AÇÃO DO SISAF"
        />
      </ContainerConteudo>
      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              data,
              valoresExibidosLogsAcoes,
              fieldObjectUsuario,
              'sisaf_logs_acoes.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};
export default DadosAcessos;
